IconButton = require 'components/common/icon_button'
QuestionCodes = require 'components/common/question_codes'
Translation = require 'components/mixins/translation'
{ convertToList } = require 'lib/question_tags_helper'
{
  QUESTION_TAG_ITEM_DND_TYPE
  dragSpec
  dropSpec
  dragCollect
  dropCollect
} = require './question_tag_item_dnd_spec'

QUESTION_TAGS_PROPS =
  onAddCode: PropTypes.func.isRequired
  onAddTag: PropTypes.func.isRequired
  onMoveTag: PropTypes.func.isRequired
  onRemoveCode: PropTypes.func.isRequired
  onRemoveTag: PropTypes.func.isRequired
  onUpdateTag: PropTypes.func.isRequired
  codeEnabledTags: PropTypes.arrayOf(PropTypes.string)
  displayCodes: PropTypes.bool
  question: PropTypes.instanceOf(Immutable.Map).isRequired
  renderShortVersionOfTagContent: PropTypes.func
  renderTagContent: PropTypes.func
  tags: PropTypes.arrayOf(PropTypes.string).isRequired

TAG_ITEM_PROPS =
  canDrag: PropTypes.bool.isRequired
  children: PropTypes.node
  displayCodes: PropTypes.bool.isRequired
  displayDelete: PropTypes.bool.isRequired
  index: PropTypes.number.isRequired
  itemId: PropTypes.string.isRequired
  renderShortVersionOfTagContent: PropTypes.func
  tag: PropTypes.instanceOf(Immutable.Map).isRequired
  tagType: PropTypes.string.isRequired

TagItem = createReactClass
  displayName: 'QuestionTagItem'
  propTypes: _.extend TAG_ITEM_PROPS, _.pick QUESTION_TAGS_PROPS,
    'onAddCode', 'onMoveTag', 'onRemoveCode', 'onRemoveTag', 'onUpdateTag'

  itemRef: (el) ->
    @item = el

  handleTagNameChange: (e) ->
    { onUpdateTag, tag } = @props
    updatedTag = tag.set 'name', e.target.value
    onUpdateTag updatedTag

  handleTagDelete: ->
    { onRemoveTag, tag } = @props
    onRemoveTag tag

  toggleExpanded: ->
    @setState expanded: not @state.expanded

  getInitialState: ->
    expanded: false

  render: ->
    {
      canDrag
      children
      connectDragSource
      connectDropTarget
      displayCodes
      displayDelete
      isDragging
      isOver
      onAddCode
      onRemoveCode
      tag
      renderShortVersionOfTagContent
    } = @props

    className = classNames 'tags__tag-item mb-10', {
      dragging: isDragging
      over: isOver
      expanded: @state.expanded
    }

    connectDragSource(
      connectDropTarget(
        <div className={className} ref={@itemRef}>
          {canDrag and <div className="drag-marker" />}
          <div className="tag-item__name">
            <input
              type="text"
              value={tag.get 'name'}
              onChange={@handleTagNameChange}
            />
          </div>
          {displayDelete and <div className="tag-item__delete-tag-item">
            <IconButton iconName="decline-icon" onClick={@handleTagDelete} />
          </div>}
          {displayCodes and <div className="tag-item__codes">
            <QuestionCodes
              codeGroup={tag.get 'type'}
              codes={tag.get 'codes'}
              onAdd={onAddCode}
              onRemove={onRemoveCode}
              parentId={tag.get 'id'}
            />
          </div>}
          {renderShortVersionOfTagContent and renderShortVersionOfTagContent
            tag: tag
            tagType: tag.get('type')
          }
          {children? and <div className="tag-item__toggle-content">
            <IconButton
              iconName={if @state.expanded then 'collapse' else 'expand'}
              onClick={@toggleExpanded}
            />
          </div>}
          {children? and @state.expanded and <div className="tag-item__content">{children}</div>}
        </div>
      )
    )

DragSourcedTagItem = ReactDnD.DragSource(
  QUESTION_TAG_ITEM_DND_TYPE, dragSpec, dragCollect
) TagItem
DraggableTagItem = ReactDnD.DropTarget(
  QUESTION_TAG_ITEM_DND_TYPE, dropSpec, dropCollect
) DragSourcedTagItem

TAG_PROPS =
  tagType: PropTypes.string.isRequired

Tag = createReactClass
  displayName: 'QuestionTag'
  mixins: [Translation()]
  propTypes: _.extend TAG_PROPS, _.pick QUESTION_TAGS_PROPS,
    'displayCodes', 'onAddCode', 'onAddTag', 'onMoveTag', 'onRemoveCode',
    'onRemoveTag', 'onUpdateTag', 'question', 'renderShortVersionOfTagContent',
    'renderTagContent'

  handleAddTagItem: ->
    { onAddTag, tagType } = @props
    onAddTag tagType

  renderTagItemContent: (tag) ->
    { renderTagContent } = @props
    return null unless renderTagContent?

    renderTagContent
      tag: tag
      tagType: tag.get('type')

  render: ->
    {
      codeEnabledTags
      displayCodes
      onAddCode
      onMoveTag
      onRemoveCode
      onRemoveTag
      onUpdateTag
      question
      renderShortVersionOfTagContent
      renderTagContent
      tagType
    } = @props

    displayAddButton = not _.include ['comparison', 'comparatorTest'], tagType
    shouldDisplayCodes = if displayCodes
      if codeEnabledTags?
        _.include codeEnabledTags, tagType
      else
        not _.include ['comparison' ,'comparatorTest', 'outcome'], tagType
    else
      false

    includedTags = Immutable.fromJS convertToList question.get 'includedTags', Immutable.List()
    tags = includedTags
      .filter (tag) -> tag.get('type') is tagType and tag.get('included') is true

    tagIndexes = {}
    includedTags.forEach (tag, idx) ->
      tagIndexes[tag.get('id')] = idx

    canDragOrDelete = tags.size > 1

    <div className="mb-20 question-tags__question-tag">
      <div className="question-tag__label">
        {_.str.capitalize @i18n "es:question.#{_.str.underscored tagType}"}
      </div>
      <div className="question-tag__tags">
        {tags.map (tag) =>
          <DraggableTagItem
            canDrag={canDragOrDelete}
            displayCodes={shouldDisplayCodes}
            displayDelete={canDragOrDelete}
            index={tagIndexes[tag.get('id')]}
            itemId={tag.get 'id'}
            key={tag.get 'id'}
            onAddCode={onAddCode}
            onMoveTag={onMoveTag}
            onRemoveCode={onRemoveCode}
            onRemoveTag={onRemoveTag}
            onUpdateTag={onUpdateTag}
            renderShortVersionOfTagContent={renderShortVersionOfTagContent}
            tag={tag}
            tagType={tagType}
          >
            {@renderTagItemContent tag}
          </DraggableTagItem>
        .toList()}
        {displayAddButton and <div className="tags__add-tag-item">
          <IconButton
            iconName="add"
            inlined
            label={@i18n "actions.add_#{_.str.underscored tagType}"}
            labelPosition="right"
            onClick={@handleAddTagItem}
          />
        </div>}
      </div>
    </div>

Tags = createReactClass
  displayName: 'QuestionTags'
  propTypes: QUESTION_TAGS_PROPS

  getDefaultProps: ->
    codeEnabledTags: null
    displayCodes: true
    renderShortVersionOfTagContent: null
    renderTagContent: null

  render: ->
    {
      codeEnabledTags
      onAddCode
      onAddTag
      onMoveTag
      onRemoveCode
      onRemoveTag
      onUpdateTag
      question
      displayCodes
      renderShortVersionOfTagContent
      renderTagContent
      tags
    } = @props

    <div className="question-tags">
      {_.map tags, (tagType) ->
        <Tag
          key={tagType}
          codeEnabledTags={codeEnabledTags}
          onAddCode={onAddCode}
          onAddTag={onAddTag}
          onMoveTag={onMoveTag}
          onRemoveCode={onRemoveCode}
          onRemoveTag={onRemoveTag}
          onUpdateTag={onUpdateTag}
          question={question}
          displayCodes={displayCodes}
          renderShortVersionOfTagContent={renderShortVersionOfTagContent}
          renderTagContent={renderTagContent}
          tagType={tagType}
        />
      }
    </div>

module.exports = {
  QUESTION_TAGS_PROPS
  QuestionTags: Tags
}
